import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  title: "Attributes",
  description:
    "In this type of experiment, the participant has to rate attributes of two differently generated audio stimuli.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [4, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "iframe",
                options: {
                  src: `${config.IFRAMES_STATIC_URL}/0224-tests/att.html`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "hint",
                options: {
                  direction: "row",
                  size: "large-thin",
                  color: "primary",
                  data:
                    "Often it is also helpful to introduce a definition of terms such as “naturalness” or “pleasentness” to make sure, the participants have a common understanding of the used terms.",
                },
              },
              styles: {
                padding: "0 9.5%",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
